const SCRIPT_SRC = 'https://connect.facebook.net/en_US/sdk.js'

let loadPromise: Promise<void> | null = null

export function loadFacebookScript(appId: string): Promise<void> {
    if (loadPromise) return loadPromise

    loadPromise = new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
            window.FB.init({ appId, cookie: true, xfbml: false, version: 'v20.0' })
            resolve()
            return
        }

        ;(window as any).fbAsyncInit = () => {
            window.FB.init({ appId, cookie: true, xfbml: false, version: 'v20.0' })
            resolve()
        }

        const script = document.createElement('script')
        script.src = SCRIPT_SRC
        script.async = true
        script.defer = true
        script.onerror = () => reject(new Error('Failed to load Facebook SDK'))
        document.head.appendChild(script)
    })

    return loadPromise
}

declare global {
    interface Window {
        FB: any
        fbAsyncInit: () => void
    }
}
